import React from 'react';
import './see-more.scss';
import PropTypes from 'prop-types';

const SeeMore = props => {
  const { rows, children, seeMoreClass = 'ellipsis--see-more' } = props;
  let { lineHeight } = props;
  const contentRef = React.useRef();
  const [hidden, setHidden] = React.useState(false);
  const [seeMoreClicked, setSeeMoreClicked] = React.useState(false);
  const [lh, setLh] = React.useState(lineHeight);
  setTimeout(() => {
    const contentHeight = contentRef?.current?.clientHeight || 0;
    if (contentRef?.current === null) return null;
    if (!lineHeight) {
      const style = window?.getComputedStyle(contentRef?.current, '');
      const lh = style?.getPropertyValue('line-height');
      lineHeight = parseInt(lh);
      setLh(lineHeight);
    }
    if (!seeMoreClicked && contentHeight > rows * lineHeight) {
      setHidden(true);
    }
  });
  return (
    <div className="ellipsis" ref={contentRef}>
      <div
        className="ellipsis--content"
        style={{ height: hidden ? `${rows * lh}px` : 'auto' }}
      >
        {children}
      </div>
      {hidden && (
        <div
          className={seeMoreClass}
          onClick={() => {
            setHidden(false);
            setSeeMoreClicked(true);
          }}
        >
          See More
        </div>
      )}
    </div>
  );
};

SeeMore.propTypes = {
  rows: PropTypes.number.isRequired,
  lineHeight: PropTypes.number,
  seeMoreClass: PropTypes.string,
};

export default SeeMore;
